import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { BitmapText } from '@pixi/react';
import { FOLDED_TEXT, REVEAL_ON_TEXT, REVEAL_TEXT } from '../../../stringConstants';
import { getBitmapTextDimensions } from '../../../utils/textMetricsUtils';
import { assertUnreachable } from '../../../utils/tsUtils';
import { isTestEnvironment } from '../../../utils/utils';
function renderBitmapText(text, bitmapTextStyleType, pixiDataType) {
    const dimensions = getBitmapTextDimensions(text, bitmapTextStyleType);
    return (_jsx(BitmapText
    // Workaround an apparent bug in react-pixi-fiber that doesn't see changes in style.fontName by explicitly setting a unique key value:
    , { x: -Math.round(dimensions.w / 2), y: -Math.round(dimensions.h / 2), text: text, "pixi-data": isTestEnvironment() ? { type: pixiDataType } : null, style: { fontName: bitmapTextStyleType } }, `${bitmapTextStyleType}-${text}`));
}
/**
 * After you have folded, shows the 'Folded' overlay by default, 'Reveal' on hover,
 * or 'Reveal On' if the hole cards have been clicked and revealing is turned on for the hand.
 */
export const HoleCardsOverlayContainer = ({ mode }) => {
    switch (mode) {
        case 'folded': {
            return renderBitmapText(FOLDED_TEXT, 'folded-hole-cards', 'hole-cards-folded-overlay');
        }
        case 'revealing': {
            return renderBitmapText(REVEAL_ON_TEXT, 'reveal-overlay', 'hole-cards-revealing-overlay');
        }
        case 'reveal': {
            return renderBitmapText(REVEAL_TEXT, 'reveal-overlay', 'hole-cards-reveal-overlay');
        }
        case undefined: {
            return null;
        }
        default: {
            assertUnreachable(mode);
        }
    }
};
